export type DomiAuthEnvironment = 'local' | 'test' | 'prod';

export function resolveDomiAuthEnvironment(hostname: string): DomiAuthEnvironment | null {
  const normalized = hostname.trim().toLowerCase();
  if (normalized === 'localhost' || normalized === '127.0.0.1' || normalized === '::1') {
    return 'local';
  }
  if (
    normalized.startsWith('test.') ||
    normalized.startsWith('test-') ||
    normalized.endsWith('.domi-kids.com') ||
    normalized.endsWith('.maliang.me') ||
    normalized === 'maliang.me'
  ) {
    return 'test';
  }
  if (
    /^(?:www\.)?domi-kids\.(?:com|cn|ai)$/.test(normalized) ||
    /^(?:www\.)?domikids\.[a-z0-9.-]+$/.test(normalized)
  ) {
    return 'prod';
  }
  return null;
}

export function resolveDomiSsoCookieName(hostname: string): string {
  const environment = resolveDomiAuthEnvironment(hostname);
  if (environment === 'local') return 'domi_sso_token_local';
  if (environment === 'test') return 'domi_sso_token_test';
  return 'domi_sso_token_prod';
}
